export const Loader = () => {
  return (
    <section className="custom-loader-wrapper">
      <span className="custom-loader"></span>
    </section>
  );
};
